/**
 * Gen1TrunkingOrderRepeaterSerials テーブル用 ViewModel
 * API レスポンスのマッピング用。
 */
export default class {
    constructor(dataObject = null) {
        this.id = 0;
        this.Gen1TrunkingOrderHeaderId = 0;
        this.OrderNumber = '';
        this.ExchangePairId = null;
        this.ExchangeSystemId = '';
        this.OperationType = ''; // ADD | REMOVE
        this.BaseModel = '';
        this.MarketCode = '';
        this.SerialNumber = '';
        this.LineSequenceNumber = 0;

        if (dataObject) {
            try {
                this.id = dataObject.id ?? 0;
                this.Gen1TrunkingOrderHeaderId =
                    dataObject.Gen1TrunkingOrderHeaderId ?? 0;
                this.OrderNumber = dataObject.OrderNumber ?? '';
                this.ExchangePairId = dataObject.ExchangePairId ?? null;
                this.ExchangeSystemId = dataObject.ExchangeSystemId ?? '';
                this.OperationType = dataObject.OperationType ?? '';
                this.BaseModel = dataObject.BaseModel ?? '';
                this.MarketCode = dataObject.MarketCode ?? '';
                this.SerialNumber = dataObject.SerialNumber ?? '';
                this.LineSequenceNumber = dataObject.LineSequenceNumber ?? 0;
            } catch (e) {
                throw new Error(
                    'Data import error @ Gen1TrunkingOrderRepeaterSerial.'
                );
            }
        }
    }
}
